/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { FlightCompaniesResponse } from '../../models/flight-companies-response';

export interface CommonControllerGetFlightCompanies$Params {
}

export function commonControllerGetFlightCompanies(http: HttpClient, rootUrl: string, params?: CommonControllerGetFlightCompanies$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: FlightCompaniesResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, commonControllerGetFlightCompanies.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: FlightCompaniesResponse;
      }>;
    })
  );
}

commonControllerGetFlightCompanies.PATH = '/common/flight-companies';
